const DPO_DAY_TARGET_URL =
  'https://www.sympla.com.br/evento/dpoday-2027-governanca-de-dados-na-era-dos-agentes-de-ia/3469269?token=a3a97ee14beb9586bfee03a1702f2032'
const DPO_DAY_STORAGE_KEY_PREFIX = 'dpo-day-banner-preferences'
const DPO_DAY_FLOATING_BUTTON_STORAGE_KEY_PREFIX =
  'dpo-day-floating-button-preferences'
const DPO_DAY_BANNER_DEFAULT_VARIANT = 'default'
const DPO_DAY_BANNER_COUNTDOWN_VARIANT = 'countdown'
const DPO_DAY_BANNER_HIDDEN_VARIANT = 'hidden'
const DPO_DAY_BANNER_MIXPANEL_TAG = 'banner-dpoday'
const DPO_DAY_PILL_COLORS = {
  GREEN: 'green',
  PINK: 'pink',
}
const dpoday = {
  DPO_DAY_TARGET_URL,
  DPO_DAY_STORAGE_KEY_PREFIX,
  DPO_DAY_FLOATING_BUTTON_STORAGE_KEY_PREFIX,
  DPO_DAY_BANNER_DEFAULT_VARIANT,
  DPO_DAY_BANNER_COUNTDOWN_VARIANT,
  DPO_DAY_BANNER_HIDDEN_VARIANT,
  DPO_DAY_PILL_COLORS,
  DPO_DAY_BANNER_MIXPANEL_TAG,
}

export default dpoday
